// Central theme file for BOCA V2 POS system
// Add all reused colors and theme variables here

const lightTheme = {
  colors: {
    primary: '#1310d8', // Main blue
    secondary: '#d4af37', // Gold accent
    background: '#f5f6fa',
    surface: '#fff',
    error: '#e74c3c',
    text: '#222',
    textLight: '#fff',
    textSecondary: '#666',
    border: '#aaa',
    success: '#27ae60',
    warning: '#f39c12',
  },
  fonts: {
    main: 'Roboto, Arial, sans-serif',
    heading: 'Montserrat, Arial, sans-serif',
  },
  borderRadius: '8px',
  boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
};

const darkTheme = {
  colors: {
    primary: '#d4af37', // Gold accent
    secondary: '#568af3ff', // Main blue
    background: '#181818',
    surface: '#222',
    error: '#e74c3c',
    text: '#f5f6fa',
    textLight: '#fff',
    textSecondary: '#aaa',
    border: '#444',
    success: '#27ae60',
    warning: '#f39c12',
  },
  fonts: {
    main: 'Roboto, Arial, sans-serif',
    heading: 'Montserrat, Arial, sans-serif',
  },
  borderRadius: '8px',
  boxShadow: '0 2px 8px rgba(0,0,0,0.32)',
};

export { lightTheme, darkTheme };
